import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import { useStore } from 'zustand';
import type { ViewerState, ViewerStore } from './viewer-store';

const ViewerStoreContext = createContext<ViewerStore | null>(null);

export function ViewerStoreProvider({
  store,
  children,
}: {
  store: ViewerStore;
  children: ReactNode;
}) {
  return <ViewerStoreContext value={store}>{children}</ViewerStoreContext>;
}

/** Select a slice of viewer state (re-renders only when the slice changes). */
export function useViewer<T>(selector: (state: ViewerState) => T): T {
  const store = useContext(ViewerStoreContext);
  if (!store) throw new Error('useViewer must be used within a ViewerStoreProvider');
  return useStore(store, selector);
}

/** Access the store handle (for imperative getState/subscribe outside render). */
export function useViewerStoreHandle(): ViewerStore {
  const store = useContext(ViewerStoreContext);
  if (!store) throw new Error('useViewerStoreHandle must be used within a ViewerStoreProvider');
  return store;
}
